import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  EventEmitter,
  Output,
  ViewChild
} from "@angular/core";
import * as utils from "@foh/shared/services/utils";
import { ActivatedRoute } from '@angular/router';
import { NgbDatepicker, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { ReservationformService } from "@foh/publicpages/reservationform/reservationform.service";

@Component({
  selector: "app-reservation-fields-form",
  templateUrl: "./reservation-fields-form.component.html",
  styleUrls: ["./reservation-fields-form.component.scss"]
})
export class ReservationFieldsFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() record: any = {};
  @Input() guests: any;
  @Input() branches: any;
  @Input() slots: any;
  @Input() isReadOnly: boolean = false;
  @Input() modeIsEdit: boolean = false;
  @Input() disclaimerText = "";
  @Input("show-branch") showBranchRow: boolean;
  @Input("show-seating-type") showSeatingType: boolean = true;
  @Input("show-slot-end-time") showSlotEndTime: boolean = true;
  @Input("cutoff-time") cutOffTime: any;
  @Input("note-text") noteText: string = null;
  @Input("comments-label") commentsLabel: string = null;
  @Input("public-tags") publicTags: any = [];
  @Input("create-customer-as-guest") createCustomerAsGuest: boolean;
  @Output("on-slot-change") onSlotChange = new EventEmitter<any>();
  @Output("on-guestlist-status-change") onGuestListStatusChange = new EventEmitter<any>();
  @Output("on-tickettype-change") onTicketTypeChange = new EventEmitter<any>();
  @Output("on-ticket-price-change") onTicketPriceChange = new EventEmitter<any>();
  @Output("validate-pax-for-clientCateogry") validatePax = new EventEmitter<boolean>();
  @Output("validate-min-pax") validateMinPax = new EventEmitter<boolean>();
  minPax!: any;

  showGuestsList: boolean = false;
  isTicketType: boolean = false;
  availableSlots: boolean = false;
  ticketPrices: any;
  @ViewChild("d2") datePicker: NgbDatepicker;
  minimumDate: any;
  maximumDate: any;
  branchId: number
  preSelectedBranchId: any = null;
  preSelectedDate: NgbDate = null;
  preSelectedDateObject: any = null;
  preSelectedBranchName: any = null;
  markDateAsClosedForCuttoff: boolean = false;
  selectedSlot: any
  excludedGL: boolean = false
  maxPax
  maxPaxExceeded

  constructor(private service: ReservationformService, private activatedRoute: ActivatedRoute) {
    var todayDate = new Date();
    this.minimumDate = {
      year: todayDate.getFullYear(),
      month: todayDate.getMonth() + 1,
      day: todayDate.getDate()
    };
  }

  ngOnInit() {
    this.datePicker.minDate = this.minimumDate; //I am setting the value at component not the html because minDate [The DatePicker] was clashing with minDate [Ng2-validation]
    //Check if prefil params are there
    this.activatedRoute.queryParams
      .subscribe(params => {
        if (typeof params['s'] !== "undefined") {
          this.record.source = params['s'];
        }
        if (typeof params['d'] !== "undefined" && typeof params['m'] !== "undefined" && typeof params['y'] !== "undefined") {

          this.preSelectedDate = new NgbDate(parseInt(params['y']), parseInt(params['m']), parseInt(params['d']));
          this.preSelectedDateObject = {
            year: parseInt(params['y']),
            month: parseInt(params['m']),
            day: parseInt(params['d'])
          };
        }
        if (typeof params['bid'] !== "undefined") {
          this.branchId = parseInt(params['bid'])
        }
      }
      );
  }

  ngOnChanges(changes) {
    if (typeof changes.branches !== "undefined" && !changes.branches.firstChange && changes.branches.currentValue.length > 0) {
      this.managePrecheckValues();
    }
    if (typeof changes.cutOffTime !== "undefined" && !changes.cutOffTime.firstChange && changes.cutOffTime.currentValue != -1) {
      this.manageCutOffDate();
    }
  }

  ngOnDestroy() {
    this.onSlotChange.unsubscribe();
    this.onSlotChange = null;
    this.onGuestListStatusChange.unsubscribe();
    this.onGuestListStatusChange = null;
    this.onTicketTypeChange.unsubscribe();
    this.onTicketTypeChange = null;
    this.onTicketPriceChange.unsubscribe();
    this.onTicketPriceChange = null;
  }

  updateSlotsDelayed() {
    setTimeout(() => {
      this.updateSlots(false);
    }, 40);
  }

  updateSlots(forceSlotId) {
    if (this.markDateAsClosedForCuttoff) {
      return;
    }
    for (var i = 0; i < this.branches.length; i++) {
      if (this.branches[i].id == this.record.branch_id) {
        this.slots = utils.filterSlotsPerDate(
          this.record.date,
          this.branches[i]["slots"],
          true
        );
        if (this.slots.length > 0) {
          if (forceSlotId === false) {
            this.record.slot_id = this.slots[0].id;
          } else {
            this.record.slot_id = forceSlotId;
          }

          this.availableSlots = true;
        } else {
          this.record.slot_id = null;
          this.availableSlots = false;
        }
        this.recheckSlotGuestList();
        this.refreshTagsVisibility();
        this.checkGl(this.record.pax);
        break;
      }
    }

    this.slots = this.updateSlotsBasedOnDate(this.slots);
  }

  updateSlotsBasedOnDate(slots: any[]): any[] {
  //  console.log("⏳ Checking slots...");

    const isToday = this.isToday(this.record.date);
 //   console.log("📆 Is Today:", isToday);

    if (isToday) {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinutes = now.getMinutes();
     //   console.log(`⏰ Current Time: ${currentHour}:${currentMinutes}`);

        const filteredSlots = slots.filter(slot => {
            const [fromHour, fromMinutes] = slot.timefrom.split(":").map(Number);
            const [toHour, toMinutes] = slot.timeto.split(":").map(Number);
          //  console.log(`🕒 Slot: ${slot.timefrom} - ${slot.timeto}  | Parsed: ${fromHour}:${fromMinutes} → ${toHour}:${toMinutes}`);

            const isOvernight = toHour < fromHour || (toHour === fromHour && toMinutes < fromMinutes);
           // console.log("🌙 Is Overnight Slot?", isOvernight);

            if (isOvernight) {
                const inTodayPart = currentHour > fromHour || (currentHour === fromHour && currentMinutes >= fromMinutes);
                const inTomorrowPart = currentHour < toHour || (currentHour === toHour && currentMinutes < toMinutes);

               // console.log(`✅ In Today Part: ${inTodayPart} | ✅ In Tomorrow Part: ${inTomorrowPart}`);
                
                return inTodayPart || !inTomorrowPart;
            } else {
                const isStillValid = toHour > currentHour || (toHour === currentHour && toMinutes > currentMinutes);
             //   console.log(`🔎 Is Still Valid? ${isStillValid}`);

                return isStillValid;
            }
        });

     //   console.log("🎯 Filtered Slots:", filteredSlots);
        return filteredSlots;
    }

 //   console.log("📌 Returning all slots since it's not today.");
    return slots;
}


  
  
  
  isToday(date: { year: number; month: number; day: number }): boolean {
    if (!date || !date.year || !date.month || !date.day) {
      return false; // Prevent errors if date is undefined or missing properties
    }
  
    const today = new Date();
    return (
      date.year === today.getFullYear() &&
      date.month === today.getMonth() + 1 &&
      date.day === today.getDate()
    );
  }

  onSlotUpdate() {   
    this.updateMinPax();
    this.calcNumberOfPeople(this.record.pax);

    // for(let i = 0; i < this.slots.length; ++i) {
    //   if(this.record.slot_id == this.slots[i].id) {
    //     this.record.reservation_form_min_pax = this.slots[i].reservation_form_min_pax;
    //     // this.record.pax = this.record.reservation_form_min_pax;
    //   }
    // }

    this.checkGlExcludedCategories()
    this.recheckSlotGuestList();
    this.refreshTagsVisibility();
    this.checkGl(this.record.pax);
  }

  private updateMinPax() {
    let slot = this.getSlotById(this.record.slot_id);
    this.minPax = slot.reservation_form_min_pax;
  }

  checkGlExcludedCategories() {
    let body = {
      mobileNo: this.record.mobileno,
      slotId: this.record.slot_id
    }
    this.service.checkGuestList(body).subscribe((response: any) => {
      this.excludedGL = response.skipGL
      this.maxPax = response.maxPax
      if (this.excludedGL) {
        this.diactivateGuestList()
      }
    })
  }

  diactivateGuestList() {
    this.onGuestListStatusChange.emit(false)
  }

  updateTags() {
    this.populatePublicTags();
  }

  manageCutOffDate() {
    this.markDateAsClosedForCuttoff = false;
    if (this.cutOffTime == -1) {
      return;
    }

    var todayDate = new Date();

    //Check current 
    var cutOffArray = this.cutOffTime.split(":");
    var cuttOffDate = new Date();
    cuttOffDate.setHours(cutOffArray[0]);
    cuttOffDate.setMinutes(cutOffArray[1]);
    cuttOffDate.setSeconds(0);
    if (this.preSelectedDateObject !== null) {
      var preSelectedDateJavaScriptDateObject = new Date(this.preSelectedDateObject.year, this.preSelectedDateObject.month - 1, this.preSelectedDateObject.day);
      var todayDateWithoutSeconds = new Date();
      todayDateWithoutSeconds.setHours(0);
      todayDateWithoutSeconds.setMinutes(0);
      todayDateWithoutSeconds.setSeconds(0);
      todayDateWithoutSeconds.setMilliseconds(0);
      if (preSelectedDateJavaScriptDateObject.getTime() === todayDateWithoutSeconds.getTime()) {
        //If The Preselected Date is today & 
        if (todayDate.getTime() >= cuttOffDate.getTime()) {
          this.markDateAsClosedForCuttoff = true;
          this.record.slot_id = null;
        }
      }
      return;
    }

    if (todayDate.getTime() >= cuttOffDate.getTime()) {
      //Cutoff time, Add 1 day to minimum date
      todayDate.setDate(todayDate.getDate() + 1);
    }
    this.minimumDate = {
      year: todayDate.getFullYear(),
      month: todayDate.getMonth() + 1,
      day: todayDate.getDate()
    };
    this.datePicker.minDate = this.minimumDate; //I am setting the value at component not the html because minDate [The DatePicker] was clashing with minDate [Ng2-validation]
    this.record.date = this.minimumDate;
  }

  calcNumberOfPeople(numberOfPeople: string) {
    const sanitizedValue = String(numberOfPeople).replace(/\D/g, '');
    const parsedValue = parseInt(sanitizedValue, 10);

    if (!isNaN(parsedValue) && parsedValue >= this.minPax) {
      this.record.pax = parsedValue;
      this.checkforMinPax(parsedValue);
      this.checkCCforPax(parsedValue);
      this.checkGl(parsedValue);
    } else {
      this.checkforMinPax(parsedValue);
      //this.record.pax = this.minPax;
    }
  }

  checkGl(numberOfPeople) {
    if ((this.selectedSlot.guestlistmode || this.selectedSlot.guestlistfbonly) && !this.excludedGL) {
      (numberOfPeople >= this.selectedSlot.guest_list_pax) ? this.onGuestListStatusChange.emit(true) : this.onGuestListStatusChange.emit(false)
      return
    }
    this.onGuestListStatusChange.emit(false)
  }

  checkCCforPax(numberOfPeople): boolean {
    if (numberOfPeople > this.maxPax && this.maxPax != null) {
      this.maxPaxExceeded = true
    } else {
      this.maxPaxExceeded = false
    }
    this.validatePax.emit(this.maxPaxExceeded)
    return this.maxPaxExceeded
  }

  checkforMinPax(numberOfPeople): void {
    this.updateMinPax();

    if(numberOfPeople < this.minPax) {
      this.validateMinPax.emit(true);
    } else {
      this.validateMinPax.emit(false);
    }
  }

  recheckSlotGuestList() {
    this.selectedSlot = this.getSlotById(this.record.slot_id);

    if (this.selectedSlot === false) {
      return;
    }
    if (this.onSlotChange == null) {
      return;
    }
    this.onSlotChange.emit(this.selectedSlot);
    if (this.selectedSlot.ticketmode) {
      this.showGuestsList = true;
      // this.onGuestListStatusChange.emit(this.showGuestsList);
      //this.calculateTotalPax();
      if (!this.isTicketType) {
        //this.resetGuests();
      }
      this.isTicketType = true;
      this.onTicketTypeChange.emit(this.isTicketType);
      this.injectTicketPrices(this.selectedSlot);
      return;
    } else {
      this.showGuestsList = false;
      // this.onGuestListStatusChange.emit(this.showGuestsList);
      this.isTicketType = false;
      this.onTicketTypeChange.emit(this.isTicketType);
    }
    if (this.selectedSlot.guestlistmode || this.selectedSlot.guestlistfbonly) {
      this.showGuestsList = true;
      // this.onGuestListStatusChange.emit(this.showGuestsList);
      //this.calculateTotalPax();
      return;
    } else {
      this.showGuestsList = false;
      this.onGuestListStatusChange.emit(this.showGuestsList);
    }
  }

  getSlotById(id) {
    var found: any = false;
    if (id === null) {
      return found;
    }
    var slots = this.slots;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].id == id) {
        found = {};
        found = slots[i];
        break;
      }
    }
    return found;
  }

  injectTicketPrices(selectedSlot) {
    this.ticketPrices = selectedSlot.ticketprices;
    this.onTicketPriceChange.emit(this.ticketPrices);
    if (this.ticketPrices.length > 0) {
      if (
        typeof this.record.defaultticketcat === "undefined" ||
        this.record.defaultticketcat == null
      ) {
        this.record.defaultticketcat = this.ticketPrices[0].id;
      }
      var ticketCategory = utils.getTicketCategoryById(this.record.defaultticketcat, this.ticketPrices);
      this.record.formattedTicketCategory = utils.formatTicketCategory(ticketCategory);
      if (ticketCategory.formattedValue.customdeadline) {
        this.record.formattedTicketDeadline = ticketCategory.formattedValue.deadline;
      }
    }
  }

  // removeGuest(index) {
  //   if (
  //     typeof this.guests[index].id !== "undefined" &&
  //     this.guests[index].id != -1
  //   ) {
  //     this.onGuestDelete.emit(this.guests[index].id);
  //   }
  //   this.guests.splice(index, 1);
  //   this.calculateTotalPax();
  // }

  // calculateTotalPax() {
  //   var paddingHost = 1;
  //   if (this.modeIsEdit) {
  //     paddingHost = 0;
  //   }
  //   this.record.pax = this.guests.length + paddingHost;
  // }

  chooseTable() {
    this.record.typeid = "1";
  }

  chooseBar() {
    this.record.typeid = "2";
  }

  onTicketCategoryChange(event) {
    this.record.formattedTicketCategory = "-";
    this.record.formattedTicketDeadline = null;
    var ticketCategory = utils.getTicketCategoryById(
      this.record.defaultticketcat, this.ticketPrices
    );
    this.record.formattedTicketCategory = utils.formatTicketCategory(
      ticketCategory
    );
    if (ticketCategory.formattedValue.customdeadline) {
      this.record.formattedTicketDeadline = ticketCategory.formattedValue.deadline;
    }
  }

  populatePublicTags() {
    for (var i = 0; i < this.publicTags.length; i++) {
      for (var j = 0; j < this.publicTags[i].tags.length; j++) {
        this.publicTags[i].tags[j].selected = false;
      }
      this.publicTags[i].error = false;
      this.publicTags[i].showTagCategory = this.detectTagCategoryVisibility(this.publicTags[i], this.record.slot_id);
    }
  }

  processTags() {
    var tags = [];
    var mainErrorFlag = false;
    for (var i = 0; i < this.publicTags.length; i++) {
      var categoryTags = [];
      this.publicTags[i].error = false;
      if (!this.publicTags[i].showTagCategory) {
        continue;
      }
      for (var j = 0; j < this.publicTags[i].tags.length; j++) {
        if (this.publicTags[i].tags[j].selected) {
          categoryTags.push(this.publicTags[i].tags[j].id);
          tags.push(this.publicTags[i].tags[j].id);
        }
      }
      var state = this.validateTagCategory(categoryTags, this.publicTags[i]);
      if (!state) {
        mainErrorFlag = true;
        this.publicTags[i].error = true;
      }
    }
    return { haveError: mainErrorFlag, selectedTags: tags };
  }

  validateTagCategory(selectedTags, tagCategory) {
    var numberOfSelectedTags = selectedTags.length;

    if (tagCategory.rez_minselection != null && tagCategory.rez_minselection > 0 && tagCategory.rez_minselection > numberOfSelectedTags) {
      return false;
    }
    if (tagCategory.rez_maxselection != null && tagCategory.rez_maxselection > 0 && tagCategory.rez_maxselection < numberOfSelectedTags) {
      return false;
    }
    return true;
  }
  refreshTagsVisibility() {
    for (var i = 0; i < this.publicTags.length; i++) {
      this.publicTags[i].showTagCategory = this.detectTagCategoryVisibility(this.publicTags[i], this.record.slot_id);
    }
  }

  detectTagCategoryVisibility(tagCategory, selectedSlotIdBeforeTypecast) {
    var selectedSlotId = parseInt(selectedSlotIdBeforeTypecast);
    if (tagCategory.rez_excludedslots == null || tagCategory.rez_excludedslots == "") {
      return true;
    }
    var excludedSlots = tagCategory.rez_excludedslots.split(",").map(Number);
    if (excludedSlots.includes(selectedSlotId)) {
      return false;
    }
    return true;
  }

  managePrecheckValues() {

    if (this.preSelectedDate !== null) {
      // this.datePicker.value = this.preSelectedDate;
      this.record.date = this.preSelectedDate;
    }
    if (this.branchId !== undefined) {
      this.record.branch_id = this.branchId

    }

    if (this.preSelectedBranchId !== null) {
      for (var i = 0; i < this.branches.length; i++) {
        if (this.branches[i].id == this.preSelectedBranchId) {
          this.record.branch_id = this.branches[i].id;
          this.preSelectedBranchName = this.branches[i].name;
          break;
        }
      }
    }
    this.updateSlotsDelayed();
  }

  validateTagSelection(tagCategory) {
    let selectedTags = tagCategory.tags.filter(tag => tag.selected);
    let numberOfSelectedTags = selectedTags.length;

    if (tagCategory.rez_minselection != null && numberOfSelectedTags < tagCategory.rez_minselection) {
      tagCategory.minError = true;
    } else {
      tagCategory.minError = false;
    }

    if (tagCategory.rez_maxselection != null && numberOfSelectedTags > tagCategory.rez_maxselection) {
      tagCategory.maxError = true;
    } else {
      tagCategory.maxError = false;
    }
  }

  isCheckboxDisabled(tagCategory, tag) {
    let selectedTags = tagCategory.tags.filter(t => t.selected);
    let numberOfSelectedTags = selectedTags.length;

    if (tagCategory.rez_maxselection != null) {
      if (numberOfSelectedTags >= tagCategory.rez_maxselection && !tag.selected) {
        return true;
      }
    }
    return false;
  }
}
